export const FONT_SIZE_MAPPING: Record<string, string> = {
    '1': 'x-small',
    '2': 'small',
    '3': 'medium',
    '4': 'large',
    '5': 'x-large',
    '6': 'xx-large',
    '7': 'xxx-large'
};

export const signature_placeholder = `
    <p>{date}</p>
    <p>&nbsp;</p>
    <p>Sincerely,</p>
    <p>Igor Lavskyi</p>
    <p>Front-End Dev</p>
    <p>E-mail: ihor.lavskyi@uptarget.co</p>
    <hr/>
    <p></p>
`;

export const TOAST_ID = 'HTMLForm-editor-toast';

export const MAX_AUTOSAVE_ATTEMPTS = 3;
export const SECONDS_PER_MINUTE = 60;
export const MILLISECONDS_PER_SECOND = 1000;
